<div class="modal-header ">
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close();"><span aria-hidden="true">&times;</span></button>
  <h4 class="modal-title">{{contestName.name}}</h4>
  <h3 class="text-center">{{user_Name}} - Statements</h3>
</div>
<div class="modal-body clearfix">
    <table class="table tbl-wht table-bordered table-hover table-striped" *ngFor="let data of userList.inprogress">
        <thead>
            <tr style="background: #333;">
                <th>PTS</th>
                <th>{{data.teamOneName}} VS {{data.teamTwoName}} - In progress</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let list of data.statementList; let i = index" ngDefaultControl>
                <td>{{10 - i}}</td>
                <td class="text-left" [ngbTooltip]="list.comments ? list.comments : 'No comments available'" placement="top"><span>{{list.statement}}</span></td>
            </tr>
            <tr *ngIf="data.statementList && data.statementList.length == 0">
                <td class="text-center" colspan="2">
                    <h4>
                        <small>No Statement Selected</small>
                    </h4>
                </td>
            </tr>
        </tbody>
    </table>
    <h1 class="contesViews text-center" *ngIf="userList && userList.inprogress && userList.inprogress.length === 0">
        <small>No Current Game</small>
    </h1>
    <div class="clearfix"></div>
    <hr>
    <div class="clearfix"></div>
    <table class="table tbl-wht table-bordered table-hover table-striped" *ngFor="let data of userList.completed">
        <thead>
            <tr style="background: #333;">
                <th>{{data.statementList.length > 0 ? data.statementList[0].totalPoints : ""}}</th>
                <th>{{data.teamOneName}} VS {{data.teamTwoName}} - Completed</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let list of data.statementList; let i = index" [ngClass]="{'text-danger': list.isCorrect == false, 'text-success': list.isCorrect == true}" ngDefaultControl>
                <td>{{10 - i}}</td>
                <td class="text-left" [ngbTooltip]="list.comments ? list.comments : 'No comments available'" placement="top"><span>{{list.statement}}</span></td>
            </tr>
            <tr *ngIf="data.statementList && data.statementList.length == 0">
                <td class="text-center" colspan="2">
                    <h4>
                        <small>No Statement Selected</small>
                    </h4>
                </td>
            </tr>
        </tbody>
    </table>
    <h1 class="contesViews text-center" *ngIf="userList.completed.length === 0">
        <small>No Completed Game</small>
    </h1>
</div>
